import { FormErrors } from 'redux-form';
import { calculateAge, rutValidator } from '../helpers/utils';
import { IQuoteForm } from '../store/Quote';

const regexEmail = /^[A-Z0-9._%+-]+@[A-Z0-9-]+\.[A-Z]{2,4}$/i;
const regexDate =
  /^((0?[1-9]|[12][0-9]|3[01])[- /.](0?[1-9]|1[012])[- /.](19|20)?[0-9]{2})*$/i;
const regexPhone = /^(9|2) [0-9]{4} [0-9]{4}$/i;

const validation = (values: IQuoteForm) => {
  const errors: FormErrors<IQuoteForm> = {};

  if (!values.documentId) {
    errors.documentId = 'Campo obligatorio';
  } else if (!rutValidator(values.documentId)) {
    errors.documentId = 'Rut inválido';
  }

  if (!values.birthdate) {
    errors.birthdate = 'Campo obligatorio';
  } else if (!regexDate.test(values.birthdate)) {
    errors.birthdate = 'Formato de fecha inválido, el formato es dd-mm-aaaa.';
  } else if (calculateAge(values.birthdate).years >= 60) {
    errors.birthdate =
      'Edad máxima de ingreso al seguro es de 59 años y 364 días.';
  } else if (calculateAge(values.birthdate).years < 18) {
    errors.birthdate =
      'Para contratar este seguro debes ser mayor de 18 años de edad.';
  }

  if (!values.email) {
    errors.email = 'Campo obligatorio';
  } else if (!regexEmail.test(values.email)) {
    errors.email = 'Correo inválido';
  }

  if (!values.phone) {
    errors.phone = 'Campo obligatorio';
  } else if (values.phone.replace(/ /gi, '').length < 9) {
    errors.phone = 'Teléfono inválido, debe contener 9 digitos';
  } else if (!['2', '9'].includes(String(values.phone)[0])) {
    errors.phone = 'El teléfono debe empezar por 9 o 2';
  } else if (!regexPhone.test(values.phone)) {
    errors.phone = 'El formato es incorrecto';
  }

  if (!values.charges) {
    errors.charges = 'Campo obligatorio';
  }

  return errors;
};

export default validation;
